import { render, staticRenderFns } from "./content-section.vue?vue&type=template&id=5ffc5f31&lang=pug&"
import script from "./content-section.vue?vue&type=script&lang=js&"
export * from "./content-section.vue?vue&type=script&lang=js&"
import style0 from "./content-section.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ffc5f31')) {
      api.createRecord('5ffc5f31', component.options)
    } else {
      api.reload('5ffc5f31', component.options)
    }
    module.hot.accept("./content-section.vue?vue&type=template&id=5ffc5f31&lang=pug&", function () {
      api.rerender('5ffc5f31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/content-section.vue"
export default component.exports